var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "action-box" }, [
        _c(
          "div",
          { staticClass: "action odd", staticStyle: { "padding-top": "30px" } },
          [
            _vm._m(0),
            _c("div", { staticClass: "flex row-center" }, [
              _c("div", { staticClass: "flex" }, [
                _c("img", {
                  staticStyle: { "margin-right": "20px" },
                  attrs: {
                    src: require("../../static/images/AISmart/Mask4.png"),
                    width: "480px",
                    height: "320px",
                    alt: ""
                  }
                }),
                _c(
                  "div",
                  {
                    staticClass: "flex flex-column row-around",
                    staticStyle: { height: "320px" }
                  },
                  [
                    _c("div", [
                      _vm._m(1),
                      _c(
                        "p",
                        {
                          staticStyle: { "margin-left": "65px", color: "#aaa" }
                        },
                        [
                          _vm._v(
                            "\n                当前剩余使用次数：\n                "
                          ),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#333",
                                "font-weight": "bolder"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.canUse(_vm.packageTemp.contrast) || 0
                                )
                              )
                            ]
                          )
                        ]
                      )
                    ]),
                    _c("div", { staticStyle: { width: "527px" } }, [
                      _vm._v(
                        "\n              由AI人⼯智能⽐对⽂档差异信息(支持PDF以及全系列word\n              文档差异比对，包括doc、docx、xls、xlsx、ppt、pptx;)，差异内容直观可见，导出结果精确可查，⽐对规则灵活配置，⼀键⽣成差异结果。\n            "
                      )
                    ]),
                    _c(
                      "div",
                      { staticClass: "flex" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", round: "" },
                            on: { click: _vm.buyPackge }
                          },
                          [_vm._v("前往购买")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { round: "" },
                            on: {
                              click: function($event) {
                                return _vm.useTurn("/docContrast/contrastList")
                              }
                            }
                          },
                          [_vm._v("立即使用")]
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ])
          ]
        ),
        _c("div", { staticClass: "action flex row-center column-center" }, [
          _c(
            "div",
            {
              staticClass: "flex flex-column row-around",
              staticStyle: { height: "320px" }
            },
            [
              _c("div", [
                _vm._m(2),
                _c(
                  "p",
                  { staticStyle: { "margin-left": "65px", color: "#aaa" } },
                  [
                    _vm._v("\n            当前剩余使用次数：\n            "),
                    _c(
                      "span",
                      {
                        staticStyle: { color: "#333", "font-weight": "bolder" }
                      },
                      [_vm._v(_vm._s(_vm.canUse(_vm.packageTemp.examine) || 0))]
                    )
                  ]
                )
              ]),
              _c("div", { staticStyle: { width: "527px" } }, [
                _vm._v(
                  "\n          智能审核基于海量文本语料库、知识库，根据匹配设定的审核规则和RPA机器自动化流程，增加机器审核环节，由浅及深的全面审阅档，按等级智能提示风险，⼀键生成分析报告。(支持doc、docx文字版类型的标准合同审核)\n        "
                )
              ]),
              _c(
                "div",
                { staticClass: "flex" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", round: "" },
                      on: { click: _vm.buyPackge }
                    },
                    [_vm._v("前往购买")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "useNow",
                      attrs: { round: "" },
                      on: {
                        click: function($event) {
                          return _vm.useTurn("/docExamine/examineList")
                        }
                      }
                    },
                    [_vm._v("立即使用")]
                  )
                ],
                1
              )
            ]
          ),
          _c("img", {
            staticStyle: { "margin-left": "20px" },
            attrs: {
              src: require("../../static/images/AISmart/Mask5.png"),
              width: "480px",
              height: "320px",
              alt: ""
            }
          })
        ]),
        _c("div", { staticClass: "action odd flex row-center column-center" }, [
          _c("img", {
            staticStyle: { "margin-right": "20px" },
            attrs: {
              src: require("../../static/images/AISmart/Mask2.png"),
              width: "480px",
              height: "320px",
              alt: ""
            }
          }),
          _c(
            "div",
            {
              staticClass: "flex flex-column row-around",
              staticStyle: { height: "320px" }
            },
            [
              _c("div", [
                _vm._m(3),
                _c(
                  "p",
                  { staticStyle: { "margin-left": "65px", color: "#aaa" } },
                  [
                    _vm._v("\n            当前剩余使用次数：\n            "),
                    _c(
                      "span",
                      {
                        staticStyle: { color: "#333", "font-weight": "bolder" }
                      },
                      [_vm._v(_vm._s(_vm.canUse(_vm.packageTemp.extract) || 0))]
                    )
                  ]
                )
              ]),
              _c("div", { staticStyle: { width: "527px" } }, [
                _vm._v(
                  "\n          智能文档抽取对⽂档（如：合同、裁判⽂书、票据等）的关键信息进⾏抽取，如：主体信息、标的信息、争议解决⽅式等，协助⼯作⼈员完成⾃动填表、内容⼀致性检查等⼯作，让⽂档审阅过程更⾼效。\n        "
                )
              ]),
              _c(
                "div",
                { staticClass: "flex" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", round: "" },
                      on: { click: _vm.buyPackge }
                    },
                    [_vm._v("前往购买")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "useNow",
                      attrs: { round: "" },
                      on: {
                        click: function($event) {
                          return _vm.useTurn("/docExtract/extractList")
                        }
                      }
                    },
                    [_vm._v("立即使用")]
                  )
                ],
                1
              )
            ]
          )
        ]),
        _c("div", { staticClass: "action flex row-center column-center" }, [
          _c(
            "div",
            {
              staticClass: "flex flex-column row-around",
              staticStyle: { height: "320px" }
            },
            [
              _c("div", [
                _vm._m(4),
                _c(
                  "p",
                  { staticStyle: { "margin-left": "65px", color: "#aaa" } },
                  [
                    _vm._v("\n            当前剩余使用次数：\n            "),
                    _c(
                      "span",
                      {
                        staticStyle: { color: "#333", "font-weight": "bolder" }
                      },
                      [_vm._v(_vm._s(_vm.canUse(_vm.packageTemp.draft) || 0))]
                    )
                  ]
                )
              ]),
              _c("div", { staticStyle: { width: "527px" } }, [
                _vm._v(
                  "\n          基于权威、专业的知识库，由业内顶尖专业⼈⼠构建覆盖企业20类领域的标准合同模板，每⼀条款设计都源⾃真实的实践案例和法律法规，帮助企业通过交互形式，⾼效、便捷、快速地起草合同/⽂档。\n        "
                )
              ]),
              _c(
                "div",
                { staticClass: "flex" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", round: "" },
                      on: { click: _vm.buyPackge }
                    },
                    [_vm._v("前往购买")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "useNow",
                      attrs: { round: "" },
                      on: {
                        click: function($event) {
                          return _vm.useTurn("/docDraft/draftList")
                        }
                      }
                    },
                    [_vm._v("立即使用")]
                  )
                ],
                1
              )
            ]
          ),
          _c("img", {
            staticStyle: { "margin-left": "20px" },
            attrs: {
              src: require("../../static/images/AISmart/Mask3.png"),
              width: "480px",
              height: "320px",
              alt: ""
            }
          })
        ]),
        _c(
          "div",
          {
            staticClass: "action odd common-tools",
            staticStyle: { "padding-top": "30px" }
          },
          [
            _vm._m(5),
            _c(
              "div",
              { staticClass: "tools flex row-center" },
              [
                _c(
                  "router-link",
                  { attrs: { to: "/applySign/toCreateDemo" } },
                  [
                    _c("div", {
                      staticClass: "tool coor flex row-center column-center"
                    }),
                    _c("p", { staticClass: "tool-text" }, [
                      _vm._v("签章坐标查询")
                    ])
                  ]
                ),
                _c("router-link", { attrs: { to: "/blockChain" } }, [
                  _c("div", {
                    staticClass: "tool verif flex row-center column-center"
                  }),
                  _c("p", { staticClass: "tool-text" }, [
                    _vm._v("文件/保全验证")
                  ])
                ])
              ],
              1
            )
          ]
        )
      ]),
      _c("goto-auth", {
        attrs: { authDialog: _vm.authDialog },
        on: {
          "update:authDialog": function($event) {
            _vm.authDialog = $event
          },
          "update:auth-dialog": function($event) {
            _vm.authDialog = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title-txt" }, [
      _c("span", { staticClass: "divider" }),
      _c("span", { staticClass: "title" }, [_vm._v("合同智能处理")]),
      _c("span", { staticClass: "divider" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex column-center" }, [
      _c("img", {
        attrs: {
          width: "44px",
          height: "37px",
          src: require("../../static/images/AISmart/contrast.png"),
          alt: "智能文档对比"
        }
      }),
      _c("span", { staticClass: "titleII" }, [_vm._v("智能文档对比")]),
      _c("img", {
        attrs: {
          width: "36px",
          height: "16px",
          src: require("../../static/images/AISmart/hot.png"),
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex column-center" }, [
      _c("img", {
        attrs: {
          width: "51px",
          height: "48px",
          src: require("../../static/images/AISmart/receivable.png"),
          alt: "智能文档审核"
        }
      }),
      _c("span", { staticClass: "titleII" }, [_vm._v("法律风险审核")]),
      _c("img", {
        attrs: {
          width: "36px",
          height: "16px",
          src: require("../../static/images/AISmart/hot.png"),
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex column-center" }, [
      _c("img", {
        attrs: {
          width: "48px",
          height: "46px",
          src: require("../../static/images/AISmart/remote.png"),
          alt: "智能文档抽取"
        }
      }),
      _c("span", { staticClass: "titleII" }, [_vm._v("合同关键词抽取")]),
      _c("img", {
        attrs: {
          width: "36px",
          height: "16px",
          src: require("../../static/images/AISmart/hot.png"),
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex column-center" }, [
      _c("img", {
        attrs: {
          width: "51px",
          height: "48px",
          src: require("../../static/images/AISmart/clickEdit.png"),
          alt: "合同协同起草"
        }
      }),
      _c("span", { staticClass: "titleII" }, [_vm._v("合同协同起草")]),
      _c("img", {
        attrs: {
          width: "36px",
          height: "16px",
          src: require("../../static/images/AISmart/hot.png"),
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title-txt" }, [
      _c("span", { staticClass: "divider" }),
      _c("span", { staticClass: "title" }, [_vm._v("常用工具")]),
      _c("span", { staticClass: "divider" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f1d79d5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f1d79d5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/smartContract/index.vue
// module id = rfVF
// module chunks = 149